import { PURGE_ACTIONS } from 'store/services/project/actionTypes';
import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import initialState from './initialState';

const reducerHandlers = (state = initialState, action = {}) => ({
  CANCEL_GET_ENTITIES: () => ({
    ...state,
    all: {
      ...state.all,
      data: [],
    },
  }),
  [PURGE_ACTIONS]: () => ({
    ...state,
    show: {
      ...state.show,
      data: !action.payload.data.entities.includes(state.show.data.id)
        ? state.show.data
        : {},
    },
  }),
});

export default createPaginatedListReducerWithNamedType(
  'ENTITY',
  initialState,
  reducerHandlers,
);
